// Header.js
import React from 'react';
import './Header.css'; // Import your custom styles
import logo from "../../images/splash/herbal.jpeg";
import profile from '../../images/splash/supplier1.jpg'; // Go up two directories to reach src
import { useState,useEffect,useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {Tooltip} from 'reactstrap';
import ReactToPrint from 'react-to-print';
import Select from 'react-select';
import Bill from '../Foods/bill';
import { var_api } from '../constant';


const Header = ({ onToggleSidebar }) => {

  const history = useHistory();
  const componentRefs = useRef([]);

  const getInitials = (name) => {
    const nameArray = name.split(" ");
    const initials = nameArray.map((word) => word.charAt(0).toUpperCase()).join("");
    return initials;
  };
  const emailText = localStorage.getItem('username');
  const messageCount = 3;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [orderCount, setOrderCount] = useState(0);
  const [orders, setOrders] = useState([]);
  const [modalVisible, setModalVisible] = useState(false); // State for modal visibility

  const dropdownRef = useRef(null);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false); // State to track the switch
  const notificationRef = useRef(null);
  const [showService, setShowService] = useState(false);
  const options = [
            { value: '1', label: 'New Order' },
            { value: '2', label: 'Active Order' },
            { value: '3', label: 'Completed Order' },
            { value: '4', label: 'Cancelled Order' },
            { value: '0', label: 'All' },
        ];
  const [selectedOrderLabel, setSelectedOrderLabel] = useState({
    value:'1', label: 'New Order'
  })
 const orderTypeOptions = [
  { value: '1', label: 'Customer Orders' },
  { value: '0', label: 'Admin Orders' }
];


const [selectedOrderType, setSelectedOrderType] = useState({ value: '1', label: 'Customer Orders' });
 
  const [orderHistory, setOrderHistory] = useState([]);


  const handleNotificationToggle = () => {
    const newNotificationState = !notificationsEnabled;
    setNotificationsEnabled(newNotificationState);
    localStorage.setItem('notificationsEnabled', JSON.stringify(newNotificationState)); // Save state to localStorage
    console.log("Notification")
  };
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };
  const toggleNotification = () => {
    setNotificationVisible(!notificationVisible);
  };
  // Get initials for the avatar
  const initials = getInitials(emailText);
  const dropdownStyles = {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: ' 5px 10px',
    width:"100px",
    zIndex: 1,
    textAlign: 'center'
  };
  // Generate the default avatar URL
  const defaultProfilePic = `https://ui-avatars.com/api/?name=${initials}&color=black`;
// Helper function to get initials from name
const handleClickOutside = (event) => {
  if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    setDropdownVisible(false);
  }
};
const handleClickOutsideNoti = (event) => {
  if (notificationRef.current && !notificationRef.current.contains(event.target)) {
    setNotificationVisible(false);
  }
};
useEffect(() => {
  // Define the function to retrieve and set orders
  const fetchStoredOrders = () => {
    const storedOrders = JSON.parse(localStorage.getItem('orders')) || [];
    setOrderCount(storedOrders.length);
    setOrders(storedOrders);
  };

  // Fetch orders initially
  fetchStoredOrders();

  // Set up an interval to fetch orders every 10 seconds
  // const intervalId = setInterval(fetchStoredOrders, 2000);

  // // Clear the interval when the component unmounts
  // return () => clearInterval(intervalId);
}, []);


//order history data
const fetchAllOrdersHistory = async (orderStatusFilter, orderType) => {
  const token = localStorage.getItem("Token");
  const shopId = localStorage.getItem("ShopId");

  if (!token || !shopId) {
    console.error("Missing token or shop ID");
    return;
  }

  try {
    const response = await fetch(
      `${var_api}booking-orders/order-history-bills/${shopId}/${orderStatusFilter}/${orderType}`,
      {
        method: 'GET',
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    const result = await response.json();

    if (response.ok && result.success) {
      console.log("Fetched order history:", result.data);
      setOrderHistory(result.data);

      // You can update state with result.data if needed
      // Example:
      // setOrderHistory(result.data);
    } else {
      console.error("Error fetching order history:", result.message);
    }
  } catch (error) {
    console.error("API call failed:", error);
  }
};


  // 👇 Call once when component mounts
  useEffect(() => {
    fetchAllOrdersHistory(selectedOrderLabel.value, selectedOrderType.value); // default call with empty filter
  }, []);


  // Handle click on notification
  const handleNotificationClick = (orderId) => {
    // Remove the clicked order from the orders array
    const updatedOrders = orders.filter(order => order.id !== orderId);
    setOrders(updatedOrders);
    setOrderCount(updatedOrders.length);
    localStorage.setItem('orders', JSON.stringify(updatedOrders));
    history.push('/upcoming-order');
    setNotificationVisible(false);

    // Redirect to the upcoming orders page
  };


  const handleLogout = () => {
    // Show the modal instead of logging out immediately
    setModalVisible(true);
  };


  const confirmLogout = () => {
    // Clear sensitive data
    localStorage.removeItem('Token');
    localStorage.removeItem('ShopId');
  
    // Redirect to signin and replace history
    history.replace('/');
  
    // Push a dummy state to prevent going back
    window.history.pushState(null, null, window.location.href);
  
    // Prevent back button navigation
    window.onpopstate = function () {
      history.replace('/'); // Redirect to signin if back button is clicked
    };

     // Close the modal
     setModalVisible(false);
  };


  const cancelLogout = () => {
    // Close the modal without logging out
    setModalVisible(false);
  };
  
  
// useEffect(() => {
//   if (notificationVisible) {
//     document.addEventListener("mousedown", handleClickOutsideNoti);
//   } else {
//     document.removeEventListener("mousedown", handleClickOutsideNoti);
//   }
  
//   // Clean up event listener on unmount
//   return () => {
//     document.removeEventListener("mousedown", handleClickOutsideNoti);
//   };
// }, [notificationVisible]);
useEffect(() => {
  if (dropdownVisible) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [dropdownVisible]);
  // Fetch the notification state from localStorage when the component mounts
  useEffect(() => {
    const savedNotificationState = localStorage.getItem('notificationsEnabled');
    if (savedNotificationState !== null) {
      setNotificationsEnabled(JSON.parse(savedNotificationState));
    }
  }, []);

  const handleShowServices = ()=> {
    // getShopDetails();
    setShowService(true);
  };

  const handleCloseServices = ()=> {
    // getShopDetails();
    setShowService(false);
  };

  const handleOrderLabelSelectChange = (selectedOption) => {
    setSelectedOrderLabel(selectedOption);
    fetchAllOrdersHistory(selectedOption.value);
  }
  
  const handleOrderTypeChange = (selectedOption) => {
  setSelectedOrderType(selectedOption);
  fetchAllOrdersHistory(selectedOrderLabel.value, selectedOption.value);
};


  const noResults = orderHistory.length === 0;

   const handlePrints = (index) => {
    const printContent = componentRefs.current[index];
    if (printContent) {
      const printWindow = window.open('', '', 'width=800,height=600');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print</title>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  };

  return (
    <header className="app-header">
    <div className="header-content">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img 
          src={logo} 
          alt="Logo" 
          className="logo mb-1" 
          onClick={onToggleSidebar} 
        />
        <h1 style={{ marginRight: "20px" }} className='m-1'>THATWC</h1>
      </div>
   
      <div className="profile-info">
     
        <div className="profile-pic-wrapper" style={{ position: 'relative' }} ref={dropdownRef}>
          <img 
            src={defaultProfilePic} 
            alt="Profile" 
            className="profile-pic" 
            onClick={toggleDropdown}
          />
         {dropdownVisible && (
  <div className="profile-dropdown" style={dropdownStyles}>
    {/* Optional profile image */}
  
    <div className="profile-info-text">
      <p className="profile-name">{emailText}</p>
    </div>

    {/* Divider line */}
    <div className="dropdown-divider"></div>

    {/* Logout button */}
    <button  className="logout-button" onClick={handleLogout}>
      <i className="bi bi-power" style={{ marginRight: "5px" }}></i>Logout
    </button>
  </div>
)}

        </div>
        <div className="notification-icon" onClick={toggleNotification} ref={notificationRef}>
            <i className="bi bi-bell"></i>
            {messageCount > 0 && (
              
              <span className="notification-badges">{orderCount}</span>
            )}
          </div>
          {notificationVisible && (
            <div className="notification-dropdown">
              <div style={{display:"flex",justifyContent:"center"}}>
              <h6>Notification </h6>
              {/* <label className="switch ms-2">
                <input
                  type="checkbox"
                  checked={notificationsEnabled}
                  onChange={handleNotificationToggle}
                />
                <span className="slider round"></span>
              </label> */}
              </div>
              <div className="notifications-list">
              {[...orders].reverse().map((order) => (
  <div
    key={order.id}
    className="notification-item"
    onClick={() => handleNotificationClick(order.id)}
  >
    <b>New order placed!</b> <br />Order ID: {order.id}
    {/* , Category: {order.category_name} */}
  </div>
))}

              </div>
            </div>
          )}

          <Button 
  variant="light" 
  style={{
    border: "2px solid green",
    borderRadius: "50px",
    position: "fixed", // Set position to fixed
    right: "20px", // Adjust right position as needed
    bottom: "20px", // Adjust bottom position as needed
    zIndex: "999", // Set a high z-index to ensure the button is above other content
    margin: "10px", // Add margin as needed
  }} 
  onClick={handleShowServices}
>
  <i className="bi bi-stack fs-4" style={{ color: "green" }}></i>
  <span className="badge rounded-circle bg-dark" style={{ position: "absolute", top: "-5px", right: "-5px" }}>2</span>
</Button>

 <Offcanvas show={showService} onHide={handleCloseServices} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{textAlign:"center"}}>TODAY ORDERS
          <div 
        // id="hinFood"
        >
   <h3 style={{color:"green",textShadow:"2px 2px 2px black",fontWeight:"bolder",letterSpacing:"2px"}} id="hefo" ></h3>
   {/* <div style={{ display: 'flex', alignItems: 'center', gap:"5px" }}>
   
</div> */}
   
   <div style={{ display: 'flex', alignItems: 'center', gap:"10px" }}>
    {/* <label style={{fontFamily:"serif",fontWeight:"bolder"}}>Type: 
    </label> */}
    <Select
        options={options}
        placeholder="Select Order"
        value={selectedOrderLabel}
        onChange={handleOrderLabelSelectChange}
        isSearchable={true}
        menuPlacement="top"
        className="customSelectFood"
        styles={{ menu: (provided, state) => ({
          ...provided,
          zIndex: 9999
      }) }}
       
    />
    <Select
    options={orderTypeOptions}
    value={selectedOrderType}
    onChange={handleOrderTypeChange}
    placeholder="Select Type"
    className="customSelectFood"
    styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
  />
    
   
</div>
   </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        
   <br/>


        <div id="sss">
      {
        // this.state.orderLoading ? (
        //   <div class="text-center">
        //   <div class="spinner-border" role="status">
        //     <span class="visually-hidden">Loading...</span>
        //   </div>
        // </div>
        // ) : (
          noResults ? (
            <p style={{textAlign:"center",fontWeight:"bolder"}}>Today No Orders</p>
          ) : (
            orderHistory.slice().reverse().map((order, index) => (
              <div key={index} style={{ marginTop: "-10px" }}>
                  <div id={`billContent${index}`}>
                  <Bill order={order} ref={(el) => (componentRefs.current[index] = el)} />
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    
                              {/* <Tooltip
                                  isOpen={this.state.printTooltipOpen[index]} // Use tooltip state based on index
                                  target={`printButton${index}`} // Specify the target ID of the button
                                  toggle={() => this.togglePrintTooltip(index)}
                              >
                                 Default Print
                              </Tooltip> */}
                              <div style={{ textAlign: 'center' }}>
                              
                              {/* <button
          className='btn-md btn-primary'
          id='printButton'
          style={{ borderRadius: '5px', border: 'none', padding: '7px', margin: '5px', padding: '0px auto' }}
          onClick={this.handlePrints}
        >
          <i className='bi bi-printer-fill'></i> Print
        </button> */}
       
          {/* <button className='btn-md btn-warning'  style={{ borderRadius: '5px', border: 'none', padding: '7px', margin: '5px', padding: '0px auto' }} onClick={()=>handlePrints(index)}><i className='bi bi-printer-fill'></i></button> */}
            <ReactToPrint
                  trigger={() => (
                    <div style={{ textAlign: 'center' }}>
                        {/* <button className='btn-md btn-primary' id={`printButton${index}`} style={{ borderRadius: "5px", border: "none", padding: "7px", margin:"5px", padding:"0px auto" }} onClick={() => this.togglePrintTooltip(index)}><i className="bi bi-printer-fill"></i></button> */}
                         <button
                    className="btn-md btn-warning"
                    style={{
                      borderRadius: "5px",
                      border: "none",
                      padding: "7px",
                      margin: "5px",
                    }}
                  >
                    <i className="bi bi-printer-fill"></i>
                  </button>
                    </div>
                )}
                content={() => componentRefs.current[index]}
                  // content={() => this[`componentRef${index}`]}
                  // onAfterPrint={() => this.handlePrint(order.id)}
                />
        
        
        
                              </div>
                          
                {/* <ReactToPrint
                  trigger={() => (
                    <div style={{ textAlign: 'center' }}>
                        <button className='btn-md btn-primary' id={`printButton${index}`} style={{ borderRadius: "5px", border: "none", padding: "7px", margin:"5px", padding:"0px auto" }} onClick={() => this.togglePrintTooltip(index)}><i className="bi bi-printer-fill"></i></button>
                    </div>
                )}
                  content={() => this[`componentRef${index}`]}
                  onAfterPrint={() => this.handlePrint(order.id)}
                /> */}
                  
                
                {/* <hr style={{border:"1px dashed grey",position:"relative",bottom:"110px"}}/> */}
                {/* <button className="btn-md btn-success" style={{marginRight:"4px",borderRadius:"5px",border:"none",padding:"7px"}} 
                onClick={() => this.handlePaidStatus(order.customer_id,order.id)} disabled={order.paid_status === 1}
                >{ order.paid_status === 1 ? "Paid" : "Pay" }</button>
                <button className={`btn-md btn-danger ${order.paid_status === 2 ? 'smallText' : '' }`} style={{marginRight:"4px",borderRadius:"5px",border:"none",padding:"7px"}}
                onClick={() => this.handleCancelStatus(order.customer_id,order.id)} disabled={order.paid_status === 2}
                >{ order.paid_status === 2 ? "Cancelled" : "Cancel" }</button> */}
    
               {/* { order.parcel_status === 0 &&
                <button className="btn-md btn-warning" onClick={()=> this.updateParcelInfo(order.customer_id,order.id)} style={{marginTop:"10px",borderRadius:"5px",border:"none",padding:"7px"}}>Parcel</button>
               } */}
              {/* {
               (order.pay_modes.some(mode => mode.amount > 0 && (mode.pay_mode_name === "CREDIT ORDER" || mode.pay_mode_name === "GROUP LOCATION CREDIT ORDER"))) ? null :
                <div style={{ textAlign: 'center' }}>
                   <Tooltip
        isOpen={this.state.puttooltipOpen[index]} // Use tooltip state based on index
        target={`putButton${index}`} // Specify the target ID of the button
        toggle={() => this.togglePutTooltip(index)}
      >
          Edit Paymode
        </Tooltip>
                <button className="btn btn-primary" id={`putButton${index}`} style={{borderRadius: "5px", border: "none", margin:"5px", padding:"0px 6px" }} onClick={() => {this.handleOpenEditPayModal(order); this.togglePutTooltip(index); }}><i class="bi bi-pencil-square" style={{fontSize:"14px"}}></i></button>
                <button className='btn-md btn-danger'  style={{ borderRadius: '5px', border: 'none', padding: '7px', margin: '5px', padding: '0px auto' }} onClick={()=>this.handleVoidStatus(order)}><i class="bi bi-trash"></i></button>
                </div>
              } */}
               </div>
               <br/>
               
                </div>
            
            ))
            )

        // )

      }
    
        
       
    </div>
        </Offcanvas.Body>
      </Offcanvas>
   
            
      </div>
      <Modal
        show={modalVisible}
        onHide={cancelLogout}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM!</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Logout ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={cancelLogout}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={confirmLogout}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  </header>

  
  );
};

export default Header;
